<template>
  <div :class="`articleViewBox layout_${data.neiRadio}`"
  :style="{ 'background': data.infoItme.bjColor,
  'padding': `${data.infoItme.sBj} ${data.infoItme.yeBj} ${data.infoItme.xBj}`}">
    <ul :class="`card${data.conValue}`">
      <li v-for="(item, index) in data.productList"
        :style="{ 'border-radius': data.bianjiaoRadio === '直角' ? '0px' : '8px' }" :key="index">
        <div v-if="data.neiRadio !== '1'" class="imgs">
          <div :class="`scace${data.neiRadio === '2' || data.neiRadio === '3' ? scace : '0'}`">
            <img v-if="item.src" :src="item.src" alt="">
            <img v-else src="../../assets/image-upload.jpg" alt="">
          </div>
        </div>
        <div class="text">
          <h3 :style="{ 'font-weight': data.boldRadio === '有' ? 'bold' : 'normal' }">{{ item.name }}</h3>
          <div class="time"> 2024-09-05 </div>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: 'wenzView',
  props: {
    data: Object
  },
  data () {
    return {
      scace: '1'
    }
  },
  methods: {},
  mounted () {
    console.log(this.data)
  },
  watch: {
    'data.biliRadio': function (newVal) {
      if (this.data.biliRadio === '1:1') {
        this.scace = '1'
      } else if (this.data.biliRadio === '4:3') {
        this.scace = '2'
      } else if (this.data.biliRadio === '2:1') {
        this.scace = '4'
      } else {
        this.scace = '3'
      }
    }
  }
}
</script>

<style scoped>
.articleViewBox {
  padding: 10px;
}

ul li {
  position: relative;
  overflow: hidden;
}

.layout_1 ul :nth-child(n + 2) {
  margin-top: 15px;
}

.layout_1 .text {
  padding: 15px;
}

.layout_2 .imgs {
  border-bottom-left-radius: inherit;
  border-top-right-radius: 0;
}

.layout_2 .text {
  padding: 10px 15px;
}

.layout_2 .text .time,
.layout_3 .text .time {
  margin-top: 10px;
}

.layout_2 li {
  margin-bottom: 15px;
}

.layout_3 ul {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
}

.layout_3 .text {
  padding: 15px 10px 10px;
}

.layout_3 ul li {
  margin: 0;
  width: calc(50% - 6px);
}

.layout_4 .imgs,
.layout_5 .imgs {
  float: left;
  width: 32%;
  border-bottom-left-radius: inherit;
  border-top-right-radius: 0;
}

.layout_4 .scace0,
.layout_5 .scace0 {
  padding: 0 0 100% 0;
}

.layout_4 .text,
.layout_5 .text {
  float: right;
  margin-left: 20px;
  width: calc(68% - 20px);
  padding: 20px 15px 10px 0;
}

.layout_4 ul li,
.layout_5 ul li {
  margin-bottom: 15px;
}

.layout_4 ul li:last-child,
.layout_5 ul li:last-child {
  margin-bottom: 0;
}

.layout_4 h3,
.layout_5 h3 {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  white-space: normal;
  font-size: 15px;
  margin-bottom: 12px;
}

.layout_5 .imgs {
  float: right;
}

.layout_5 .text {
  float: left;
  padding: 20px 0 10px 15px;
}

.layout_5 .text {
  margin-left: 0;
  margin-right: 20px;
}

.imgs {
  width: 100%;
  /* padding: 0 0 100% 0; */
  position: relative;
  border-radius: inherit;
}

.imgs img {
  display: block;
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  -o-object-fit: cover;
  object-fit: cover;
}

.layout_3 ul li:nth-child(n + 3) {
  margin-top: 15px;
}

ul li:before {
  content: "";
  display: block;
  width: 100%;
  height: 100%;
  z-index: 10;
  border: 1px solid transparent;
  background: none;
  position: absolute;
  left: 0;
  top: 0;
  box-sizing: border-box;
  border-radius: inherit;
}

h3 {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin: 0;
}

.card1 li {
  background: #fff;
}

.card1 li:before {
  border-color: transparent;
}

.card2 li {
  background: #fff;
  box-shadow: 0 1px 8px 0 rgba(0, 0, 0, 0.1);
}

.card2 li:before {
  border-color: transparent;
}

.card3 li {
  overflow: hidden;
  /* margin: 0;
  width: calc(50% - 6px); */
}

.card3 li:before {
  border: 1px solid #e8e8e8;
}

.card4 li {
  background: none;
}

.card4 li:before {
  border: 1px solid transparent;
}

.articleViewBox .scace1 {
  padding: 0 0 100% 0;
}

.articleViewBox .scace2 {
  padding: 0 0 75% 0;
}

.articleViewBox .scace3 {
  padding: 0 0 66.66% 0;
}

.articleViewBox .scace4 {
  padding: 0 0 50% 0;
}
</style>



// WEBPACK FOOTER //
// src/components/wenz/wenzPreview.vue